"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestAbsenceMiddleware = void 0;
const ac_1 = require("@app/ac");
const graphql_1 = require("@app/gql-types/graphql");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const use_modal_1 = require("@app/util/modal/use-modal");
const moment_1 = __importDefault(require("moment"));
const useRequestAbsenceMiddleware = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    return async (data) => {
        const shiftsInDay = shifts.filter((shift) => shift.userId === data.user &&
            (0, moment_1.default)(data.period?.start).isSame(shift?.period?.start, 'day'));
        const isAvailOrUnavail = data.categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE ||
            data.categoryId === use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE;
        if (isAvailOrUnavail) {
            const sanitizedData = {
                ...data,
                period: {
                    start: data.period?.start?.toJSON(),
                    end: data.period?.end?.toJSON(),
                },
                attachments: data.attachments?.map((att) => att.id),
                available: isAvailOrUnavail
                    ? data.categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE
                    : undefined,
                note: data.note,
                recurrenceUpdateFollowing: (0, util_1.isDefined)(data.recurrence) && (0, util_1.isUndefined)(data.id),
            };
            await dispatch((0, ac_1.setAvailabilityOrTimeOff)({
                // @ts-expect-error
                evts: [sanitizedData],
                unavId: !(0, util_1.isValue)(data.id) ? null : data.id,
            }));
            closeModal();
            // if (!res.error) {
            //   notification.success({ code: 'requestCreated' })
            // }
        }
        else {
            const res = await dispatch((0, ac_1.createTimeOffRequest)({
                workspace: workspace?.id ?? '',
                user: data.user,
                category: isAvailOrUnavail ? undefined : data.categoryId,
                avaiable: isAvailOrUnavail
                    ? data.categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE
                    : undefined,
                period: {
                    start: data.period?.start?.toJSON(),
                    end: data.period?.end?.toJSON(),
                },
                periodType: data.periodType,
                note: data.note,
                atTheStartOfShift: data?.halfDayOption === 'start',
                attachments: data.attachments
                    ? data.attachments.map((item) => item.id)
                    : [],
                shift: data.periodType === graphql_1.PeriodType.HalfDay && shiftsInDay?.length
                    ? shiftsInDay[0]?.id
                    : undefined,
            }));
            closeModal();
            if (!res.error) {
                util_1.notification.success({ code: 'requestCreated' });
            }
        }
    };
};
exports.useRequestAbsenceMiddleware = useRequestAbsenceMiddleware;
